<template>
    <v-navigation-drawer
        v-model="drawer"
        :clipped="$vuetify.breakpoint.lgAndUp"
        :permanent="$vuetify.breakpoint.lgAndUp"
        :temporary="$vuetify.breakpoint.mdAndDown"
        width="272"
        app
        color="transparent"
        class="glass-sidebar app-drawer"
        floating
    >
        <div class="app-drawer__inner">
            <nav class="app-drawer__nav">
                <template v-for="(item, i) in visibleItems">
                    <div
                        v-if="item.subheader"
                        :key="`group-${i}`"
                        class="app-drawer__group-label"
                    >
                        {{ item.label }}
                    </div>

                    <router-link
                        v-else
                        :key="`item-${i}`"
                        :to="item.to"
                        :class="['app-drawer__item', isActive(item) ? 'is-active' : null]"
                        exact-active-class="is-active"
                    >
                        <v-icon
                            :color="isActive(item) ? 'primary' : 'on-surface-variant'"
                            size="20"
                            class="app-drawer__item-icon"
                        >
                            {{ item.icon }}
                        </v-icon>
                        <span class="app-drawer__item-label">{{ item.label }}</span>
                    </router-link>
                </template>
            </nav>

            <div class="app-drawer__footer">
                <button
                    class="app-drawer__item app-drawer__item--logout"
                    @click="logout"
                >
                    <v-icon
                        size="20"
                        class="app-drawer__item-icon"
                    >
                        mdi-logout
                    </v-icon>
                    <span class="app-drawer__item-label">Sair</span>
                </button>
            </div>
        </div>
    </v-navigation-drawer>
</template>

<script>
import Api from '@/lib/Api'

export default {
    name: 'AppDrawer',
    props: {
        value: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            form: null,
        }
    },
    computed: {
        drawer: {
            get() {
                if (this.$vuetify.breakpoint.lgAndUp) {
                    return true
                }
                return this.value
            },
            set(value) {
                if (this.$vuetify.breakpoint.lgAndUp) return
                this.$emit('input', value)
            }
        },
        user() {
            return this.$store.state.currentUser
        },
        isAdmin() {
            return this.user?.admin
        },
        menuItems() {
            return [
                { label: 'Geral', subheader: true },
                { label: 'Início', icon: 'mdi-home-outline', to: '/' },
                { label: 'Meu perfil', icon: 'mdi-account-circle-outline', to: '/meu-perfil' },

                { label: 'Assistentes de IA', subheader: true },
                {
                    label: 'Artigos',
                    icon: 'mdi-file-document-outline',
                    to: '/articles',
                    hide: !this.user?.permissions.includes('ARTICLE_ASSISTANT') && !this.isAdmin,
                },
                // {
                //     label: 'Secretárias',
                //     icon: 'mdi-account-tie-woman',
                //     to: '/assistants',
                //     hide: !this.isAdmin,
                // },
                {
                    label: 'Redes Sociais',
                    icon: 'mdi-share-variant-outline',
                    to: '/social-assistant',
                    hide: !this.isAdmin && !this.user?.permissions.includes('SOCIAL_NETWORK_ASSISTANT'),
                },
                {
                    label: 'Análise de atendimentos',
                    icon: 'mdi-message-text-clock-outline',
                    to: '/atendimentos',
                    hide: !this.isAdmin
                        && !this.user?.permissions.includes('CONVERSATION_ANALYSIS'),
                },
                {
                    label: 'Presença digital',
                    subheader: true,
                    hide: !this.isAdmin
                        && !this.user?.permissions.includes('GOOGLE_BUSINESS_PROFILE')
                        && !this.user?.permissions.includes('GEO_SEO_PRESENCE'),
                },
                {
                    label: 'Presença GEO e SEO',
                    icon: 'mdi-text-box-search-outline',
                    to: '/presenca-geo-seo',
                    hide: !this.isAdmin && !this.user?.permissions.includes('GEO_SEO_PRESENCE'),
                },
                {
                    label: 'Perfil no Google',
                    icon: 'mdi-google-maps',
                    to: '/perfil-no-google',
                    hide: !this.isAdmin
                        && this.user?.role !== 'partner'
                        && !this.user?.permissions.includes('GOOGLE_BUSINESS_PROFILE'),
                },

                { label: 'Site', subheader: true, hide: !this.form },
                {
                    label: 'Meus textos',
                    icon: 'mdi-text-box-outline',
                    to: `/form-responses/${this.form?._id}/texts`,
                    hide: !this.form,
                },
                {
                    label: 'Formulário',
                    icon: 'mdi-form-select',
                    to: {
                        name: 'FormResponseSingle',
                        params: { formResponseId: this.form?._id }
                    },
                    hide: !this.form,
                },

                {
                    label: 'Plataforma',
                    subheader: true,
                    hide: !['admin', 'partner'].includes(this.user?.role),
                },
                {
                    label: 'Usuários',
                    icon: 'mdi-account-multiple-outline',
                    to: '/users',
                    hide: !this.isAdmin,
                },
                {
                    label: 'Execuções',
                    icon: 'mdi-progress-clock',
                    to: '/execucoes',
                    hide: !this.isAdmin,
                },
                {
                    label: 'Formulários',
                    icon: 'mdi-form-select',
                    to: '/forms',
                    hide: !this.isAdmin,
                },
                {
                    label: 'Criação de sites',
                    icon: 'mdi-web',
                    to: '/form-responses',
                    hide: !['admin', 'partner'].includes(this.user?.role),
                },

                { label: 'Administração Vindi', subheader: true, hide: !this.isAdmin },
                { label: 'Dashboard', icon: 'mdi-finance', to: '/vindi/dashboard', hide: !this.isAdmin },
                { label: 'Registro de ações', icon: 'mdi-history', to: '/vindi/actions', hide: !this.isAdmin },
                { label: 'Planos de assinatura', icon: 'mdi-clipboard-list-outline', to: '/vindi/plans', hide: !this.isAdmin },
                { label: 'Clientes', icon: 'mdi-account-group-outline', to: '/vindi/customers', hide: !this.isAdmin },
                { label: 'Produtos', icon: 'mdi-cube-outline', to: '/vindi/products', hide: !this.isAdmin },
                { label: 'Assinaturas', icon: 'mdi-credit-card-outline', to: '/vindi/subscriptions', hide: !this.isAdmin },
            ]
        },
        visibleItems() {
            const items = this.menuItems.filter(i => !i.hide)
            const result = []
            for (let i = 0; i < items.length; i++) {
                const item = items[i]
                if (item.subheader) {
                    const next = items[i + 1]
                    if (!next || next.subheader) continue
                }
                result.push(item)
            }
            return result
        },
    },
    methods: {
        isActive(item) {
            if (!item.to) return false
            const path = typeof item.to === 'string' ? item.to : item.to.path
            if (typeof item.to === 'object' && item.to.name) {
                return this.$route.name === item.to.name
            }
            return this.$route.path === path
        },
        logout() {
            Api.logout()
        },
        async loadForm() {
            if (!this.user?._id) {
                this.form = null
                return
            }

            const response = await this.$api.getFormResponseByUserId(this.user._id)

            if (!response.error && !response.no_form_response) {
                this.form = response.message
            }
        },
    },
    watch: {
        user: {
            immediate: true,
            handler: 'loadForm'
        }
    },
}
</script>

<style scoped>
.app-drawer >>> .v-navigation-drawer__content {
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: rgb(187 161 215 / 25%) transparent;
}

.app-drawer.v-navigation-drawer--temporary {
    background: var(--color-surface, #ffffff) !important;
    box-shadow: 0 16px 48px rgba(15, 9, 36, 0.18) !important;
}

.app-drawer >>> .v-navigation-drawer__content::-webkit-scrollbar {
    width: 4px;
}

.app-drawer >>> .v-navigation-drawer__content::-webkit-scrollbar-track {
    background: transparent;
}

.app-drawer >>> .v-navigation-drawer__content::-webkit-scrollbar-thumb {
    background-color: rgba(112, 42, 225, 0.2);
    border-radius: 4px;
}

.app-drawer >>> .v-navigation-drawer__content::-webkit-scrollbar-thumb:hover {
    background-color: rgba(112, 42, 225, 0.4);
}

.app-drawer__inner {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    padding: 16px 12px 12px;
}

.app-drawer__nav {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
}

.app-drawer__group-label {
    margin: 16px 16px 6px;
    font-size: 10px;
    font-weight: 900;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    color: var(--color-outline);
}

.app-drawer__nav > :first-child.app-drawer__group-label {
    margin-top: 8px;
}

.app-drawer__item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 14px;
    border-radius: 10px;
    text-decoration: none;
    color: var(--color-on-surface-variant);
    border-left: 4px solid transparent;
    margin-left: -4px;
    transition: background 200ms ease, color 200ms ease, transform 200ms ease;
    cursor: pointer;
    background: none;
    border-top: 0;
    border-right: 0;
    border-bottom: 0;
    width: 100%;
    font-family: var(--font-display);
    text-align: left;
}

.app-drawer__item:hover {
    background: rgba(255, 255, 255, 0.55);
    color: var(--color-on-surface);
}

.app-drawer__item.is-active {
    background: rgba(112, 42, 225, 0.1);
    color: var(--color-primary);
    border-left-color: var(--color-primary);
}

.app-drawer__item.is-active .app-drawer__item-icon {
    color: var(--color-primary) !important;
}

.app-drawer__item-label {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    line-height: 1.2;
    flex: 1;
}

.app-drawer__footer {
    padding-top: 12px;
    margin-top: 12px;
    border-top: 1px solid rgba(173, 172, 183, 0.25);
}

.app-drawer__item--logout:hover {
    color: var(--color-error);
}

.app-drawer__item--logout:hover .app-drawer__item-icon {
    color: var(--color-error) !important;
}
</style>
